import { useQuery, useQueryClient } from 'react-query'
import { initTransactionForOthers } from 'services/loans'

export default function useSetInitPayment(
    id: number,
    initialAmount: number
): {
    data: IInitTransaction | undefined
    isLoading: boolean
    refetchWithAmount: (amount: number) => Promise<IInitTransaction | undefined>
} {
    const queryClient = useQueryClient()

    const { data, isLoading } = useQuery<IInitTransaction>(
        ['init-transaction-for-others', id],
        () => initTransactionForOthers(id, initialAmount),
        {
            enabled: !!id,
        }
    )

    const refetchWithAmount = async (amount: number) => {
        try {
            const fresh = await initTransactionForOthers(id, amount)
            queryClient.setQueryData(['init-transaction-for-others', id], fresh)
            return fresh
        } catch (error) {
            console.error('refetchWithAmount error:', error)
            return undefined
        }
    }

    return { data, isLoading, refetchWithAmount }
}
